import { render, staticRenderFns } from "./iconProfile.vue?vue&type=template&id=7f4f2bf5&scoped=true"
import script from "./iconProfile.vue?vue&type=script&lang=js"
export * from "./iconProfile.vue?vue&type=script&lang=js"
import style0 from "./iconProfile.vue?vue&type=style&index=0&id=7f4f2bf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4f2bf5",
  null
  
)

export default component.exports